import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";

import reducer from "./reducer";
import rootSaga from "./saga";
// --- NEW IMPORT ---
import { injectStore } from "../services/api";

const sagaMiddleware = createSagaMiddleware();

export const store = createStore(
  reducer,
  process.env.NODE_ENV !== "production"
    ? compose(
        applyMiddleware(sagaMiddleware),
        window.__REDUX_DEVTOOLS_EXTENSION__
          ? window.__REDUX_DEVTOOLS_EXTENSION__()
          : (f) => f,
      )
    : applyMiddleware(sagaMiddleware),
);

// --- NEW LINE: Injects the store into your API service ---
injectStore(store);

sagaMiddleware.run(rootSaga);
